export default [
    { id: '1', name: 'Recaudo por Cliente', altName: 'Consulta por Cliente' },
    { id: '2', name: 'Recaudo por Lote', altName: 'Consulta por Lote' },
]